import React from "react"
import { useTranslation } from "react-i18next"

import { FormOverlay } from "shared/ui/overlay/FormOverlay"

import { ProjectFormData } from "features/project-management/types/ProjectFormData"
import { ProjectFormTabType } from "features/project-management/types/ProjectFormTabType"
import { ProjectModel } from "features/project-management/types/ProjectModel"
import { ProjectForm } from "widgets/project/project-form/ProjectForm"

const FORM_ID = "edit-project-overlay-form"

export interface EditProjectOverlayModel {
  model: ProjectModel
  onSubmit: (data: ProjectFormData) => void
  onCancel?: () => void
  activeTab?: ProjectFormTabType
  onTabChange?: (tab: ProjectFormTabType) => void
  isLoading?: boolean
  isSubmitting?: boolean
}

export const EditProjectOverlay = React.memo(
  ({
    model,
    onSubmit,
    onCancel,
    activeTab,
    onTabChange,
    isLoading,
    isSubmitting
  }: EditProjectOverlayModel) => {
    const { t } = useTranslation()

    return (
      <FormOverlay
        id="edit-project-overlay"
        form={FORM_ID}
        headline={t("Project.Actions.Update")}
        prefix="project__edit"
        onCancel={onCancel}
        isLoading={model.core.data.project?.isLoading || isLoading}
        isSubmitDisabled={isLoading}
        isDisabled={isSubmitting}
        showCloseButton
      >
        <ProjectForm
          id={FORM_ID}
          defaultFormData={{
            project: model.core.data.project?.data ?? undefined,
            clarificationRequest: {
              content:
                model.clarificationRequest?.data.clarificationRequest?.data
                  ?.content ?? null
            }
          }}
          isReadonly={false}
          isLoading={model.core.data.project?.isLoading}
          isDisabled={isSubmitting}
          onSubmit={onSubmit}
          onCancel={onCancel}
          className="overlay-form"
          model={model}
        >
          <ProjectForm.Title />
          <ProjectForm.Phase />
          <ProjectForm.Tabs
            activeTab={activeTab}
            onTabChange={onTabChange}
            className="edit-project-overlay__tabs"
          />
        </ProjectForm>
      </FormOverlay>
    )
  }
)

EditProjectOverlay.displayName = "EditProjectOverlay"
